import { WalletLoadedEvent, WalletLockedEvent, WalletUpdatedEvent } from "./models/blade";
import { noSessionError } from "./models/errors";
import { getBladeExtension } from "./helpers/interfaceHelpers";
export class LegacyConnector {
    constructor() {
        this._activeWallet = null;
        document.addEventListener(WalletLoadedEvent, async () => {
            var _a;
            this._activeWallet = ((_a = (await getBladeExtension())) === null || _a === void 0 ? void 0 : _a.getActiveWallet()) || null;
        });
        document.addEventListener(WalletUpdatedEvent, async () => {
            var _a;
            (_a = this._onAccountChanged) === null || _a === void 0 ? void 0 : _a.call(this);
        });
        document.addEventListener(WalletLockedEvent, async () => {
            var _a;
            (_a = this._onWalletLocked) === null || _a === void 0 ? void 0 : _a.call(this);
        });
    }
    onAccountChanged(callback) {
        this._onAccountChanged = callback;
    }
    onWalletLocked(callback) {
        this._onWalletLocked = callback;
    }
    getNetwork() {
        var _a;
        return ((_a = this._activeWallet) === null || _a === void 0 ? void 0 : _a.getNetwork()) || {};
    }
    getMirrorNetwork() {
        var _a;
        return ((_a = this._activeWallet) === null || _a === void 0 ? void 0 : _a.getMirrorNetwork()) || [];
    }
    async createSession(params) {
        var _a;
        // store the blade extension here
        // the logic is that some methods on the Signer interface are sync
        this._activeWallet = await ((_a = (await getBladeExtension())) === null || _a === void 0 ? void 0 : _a.createSession(params === null || params === void 0 ? void 0 : params.network, params === null || params === void 0 ? void 0 : params.dAppCode)) || null;
        const availableAccounts = [];
        if (this._activeWallet) {
            availableAccounts.push(this._activeWallet.getAccountId().toString());
        }
        return availableAccounts;
    }
    async killSession() {
        var _a;
        await ((_a = (await getBladeExtension())) === null || _a === void 0 ? void 0 : _a.killSession());
        return;
    }
    async _getActiveWallet() {
        var _a;
        const wallet = ((_a = (await getBladeExtension())) === null || _a === void 0 ? void 0 : _a.getActiveWallet()) || null;
        this._activeWallet = wallet;
        if (wallet == null) {
            throw noSessionError();
        }
        return this._activeWallet;
    }
    async sign(messages) {
        return (await this._getActiveWallet()).sign(messages);
    }
    async signTransaction(transaction) {
        return (await this._getActiveWallet()).signTransaction(transaction);
    }
    async call(request) {
        return (await this._getActiveWallet()).call(request);
    }
    async checkTransaction(transaction) {
        return (await this._getActiveWallet()).checkTransaction(transaction);
    }
    async populateTransaction(transaction) {
        return (await this._getActiveWallet()).populateTransaction(transaction);
    }
    getLedgerId() {
        var _a;
        return ((_a = this._activeWallet) === null || _a === void 0 ? void 0 : _a.getLedgerId()) || null;
    }
    getAccountId() {
        if (!this._activeWallet) {
            throw noSessionError();
        }
        return this._activeWallet.getAccountId();
    }
    async getAccountBalance() {
        return (await this._getActiveWallet()).getAccountBalance();
    }
    async getAccountInfo() {
        return (await this._getActiveWallet()).getAccountInfo();
    }
    async getAccountRecords() {
        return (await this._getActiveWallet()).getAccountRecords();
    }
    async selectAccount(accountId) {
        if (!this._activeWallet) {
            throw noSessionError();
        }
        if (accountId && this._activeWallet.getAccountId().toString() !== accountId) {
            throw noSessionError();
        }
        return this._activeWallet;
    }
    get initialized() {
        return true;
    }
}
